

// Material Dashboard 2 React base styles
import borders from "assets/theme-dark/base/borders";


// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme-dark/functions/pxToRem";
import colors from "assets/theme-dark/base/colors";


const { borderRadius } = borders;

const { light ,dark,primary,background,text} = colors;
const tableHead = {
  styleOverrides: {
    root: {

      padding: `${pxToRem(0)} ${pxToRem(0)} 0  ${pxToRem(0)}`,
      borderRadius: `${borderRadius.md} ${borderRadius.xl} 0 0`,
      '& >.MuiTableRow-root .MuiTableCell-root': {
        backgroundColor: `${background.default} !important`,
        color:primary.main,
        boxShadow: 'rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px',
        '& .MuiTableSortLabel-root': {
          fontSize: pxToRem(18), // 修改文字大小
          fontWeight: 600, // 让文字加粗
          color: primary.main, // 让文字颜色和主题一致
          '&:hover': {
            color: text.main, // 鼠标悬浮时变色
          },
          '&.Mui-active': {
            color: text.main, // 激活时的颜色
          },
        },
        '& .MuiTableSortLabel-icon': {
          fontSize: pxToRem(23), // 让箭头变大
          color: `${primary.main} !important`, // 让箭头颜色和主题一致
        },

      }
    },

  },
};


export default tableHead;
